import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { authClient, betterAuthErrorText } from "lib/auth/authClient";
import { BetterAuthError } from "../utils";

type RequestDomainVerificationResponse = {
  domainVerificationToken: string;
};

export function useDomainVerificationToken(
  providerId: string,
  options?: UseQueryOptions<
    RequestDomainVerificationResponse,
    BetterAuthError,
    RequestDomainVerificationResponse,
    readonly ["domainVerificationToken", string]
  >,
) {
  return useQuery({
    queryKey: ["domainVerificationToken", providerId] as const,
    queryFn: async (): Promise<RequestDomainVerificationResponse> => {
      const { data, error } = await authClient.sso.requestDomainVerification({ providerId });
      if (error) {
        throw new Error(betterAuthErrorText(error, "Could not request domain verification"));
      }
      return data;
    },
    ...options,
  });
}
